import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import { UserProvider } from "./providers/UserProvider";
import InterceptorProvider from "./providers/InterceptorProvider";
import AppRoutes from "routes/AppRoutes";
import "./App.css";
import "react-datepicker/dist/react-datepicker.css";
import { KPIProvider } from "providers/KPIProvider";

function App() {
    return (
        <Provider store={store}>
            <Router>
                <InterceptorProvider>
                    <UserProvider>
                        <KPIProvider>
                            <AppRoutes />
                        </KPIProvider>
                    </UserProvider>
                </InterceptorProvider>
            </Router>
        </Provider>
    );
}

export default App;
